import React from 'react';
import { Minus, Plus, X } from 'lucide-react';

const CartPage = ({ cartItems, onCheckout, onContinueShopping, onRemoveItem, updateQuantity }) => {
  const getSubtotal = () => {
    return cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  };
  const subtotal = getSubtotal();
  const shipping = 0; // Placeholder, no se suma numéricamente
  const total = subtotal + shipping; // Total solo subtotal por ahora

  if (cartItems.length === 0) {
    return (
      <div className="py-20 px-4 text-center">
        <h2 className="text-2xl font-bold mb-4">Tu carrito está vacío</h2>
        <button 
          onClick={onContinueShopping}
          className="bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors"
        >
          Continuar comprando
        </button>
      </div>
    );
  }

  const handleQuantityChange = (item, newQuantity) => {
    if (updateQuantity) {
      updateQuantity(item.id, item.color, item.size, newQuantity);
    }
  };

  return (
    <div className="py-20 px-4 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-8">Carrito de compras</h1>
      
      <div className="space-y-6 mb-8">
        {cartItems.map((item, index) => (
          <div key={`${item.id}-${item.color}-${item.size}-${item.type}-${index}`} className="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 p-4 border border-gray-200 rounded-lg">
            <div className="flex items-center space-x-4 flex-shrink-0">
              <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-bold">{item.name}</h3>
              <p className="text-gray-600 text-sm">Talla: {item.size}</p>
              <p className="text-gray-600 text-sm">Color: {item.color}</p>
              <p className="text-gray-600 text-sm">Tipo: {item.type}</p>
            </div>
            <div className="flex items-center justify-between sm:justify-end space-x-4 min-w-[200px] flex-shrink-0">
              <div className="text-right">
                <p className="font-bold text-lg">${(item.price * item.quantity).toFixed(2)}</p>
              </div>
              <div className="flex items-center space-x-2">
                <button 
                  onClick={() => handleQuantityChange(item, item.quantity - 1)} 
                  className="p-2 border rounded hover:bg-gray-100 transition-colors"
                  aria-label="Restar uno"
                >
                  <Minus size={18} />
                </button>
                <span className="w-8 text-center font-semibold">{item.quantity}</span>
                <button 
                  onClick={() => handleQuantityChange(item, item.quantity + 1)} 
                  className="p-2 border rounded hover:bg-gray-100 transition-colors"
                  aria-label="Sumar uno"
                >
                  <Plus size={18} />
                </button>
                <button 
                  onClick={() => onRemoveItem(item)} 
                  className="p-2 text-red-500 hover:text-red-700 transition-colors"
                  aria-label="Eliminar item"
                >
                  <X size={20} className="hover:scale-110" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="border-t pt-6 space-y-4">
        <div className="flex justify-between text-sm">
          <span>Envío:</span>
          <span>+ más envío dependiendo de la ciudad</span>
        </div>
        <div className="flex justify-between text-2xl font-bold border-t pt-2">
          <span>Total (productos):</span>
          <span>${total.toFixed(2)} USD</span>
        </div>
        <p className="text-center text-sm text-gray-600">El envío se calculará según tu ciudad al confirmar el pedido.</p>
      </div>

      <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 mt-8">
        <button 
          onClick={onCheckout}
          className="bg-black text-white py-3 px-6 rounded-lg font-medium hover:bg-gray-800 transition-colors flex items-center justify-center space-x-2"
        >
          <span>Continuar a WhatsApp</span>
        </button>
        <button 
          onClick={onContinueShopping}
          className="bg-gray-200 text-black py-3 px-6 rounded-lg font-medium hover:bg-gray-300 transition-colors"
        >
          Continuar comprando
        </button>
      </div>
    </div>
  );
};

export default CartPage;